export const CAMPO_SISTEMA_FACTURA = {
  NIT: 'Nit',
  REFERENCIA: 'Referencia',
  TASA: 'Tasa',
  FECHA_VENCIMIENTO: 'FechaVencimiento',
  VALOR_INICIAL: 'ValorInicial',
  DESCUENTO: 'Descuento',
  VALOR_FUTURO: 'ValorFuturo',
  TIPO_DOCUMENTO: 'TipoDocumento',
  PERSONALIZADO: 'Personalizado',
  ID_INTERNO_ERP: 'IdInternoErp'
} as const;

export type CampoSistemaFactura = typeof CAMPO_SISTEMA_FACTURA[keyof typeof CAMPO_SISTEMA_FACTURA];
